import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/pro-solid-svg-icons";
import { faCircleInfo } from "@fortawesome/pro-duotone-svg-icons";

import Button from "../../components/ui/Button";
import { useForm } from "react-hook-form";
import Auth from "../../services/Auth";
import FieldError from "../../components/ui/FieldError";
import { useNavigate } from "react-router";
import { NavLink, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Base from "../base";
import { setUser } from "../../features/auth/authSlice";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import axiosConfig from "../../services/Axios";
import LogoHead from "../../components/LogoHead";

function Login() {
  const form = useForm();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [passwordShown, setPasswordShown] = useState(false);
  const { t, i18n } = useTranslation();

  const onSubmit = async (data) => {
    try {
      await Auth.authenticate(
        { username: data.username, password: data.password },
        (user) => dispatch(setUser(user))
      );

      if (window.history.state.idx !== 0) {
        navigate(-1);
      } else {
        navigate("/");
      }
    } catch ({ response }) {
      if (response.data?.message) {
        form.setError("password", {
          type: "manual",
          message: response.data.message,
        });
      }
    }
  };

  useEffect(() => {
    window.localStorage.removeItem("authToken");
    window.localStorage.removeItem("refreshToken");
    window.localStorage.removeItem("switchUser");
    delete axiosConfig.defaults.headers["Authorization"];
  }, []);

  const togglePasswordShown = () => {
    setPasswordShown(!passwordShown);
  };

  return (
    <Base navbar={false}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="flex flex-col py-16 justify-center">
          <LogoHead />
          <div className="mx-auto my-4 lg:my-8 text-center font-semibold text-xs sm:text-base py-4 px-6 bg-gray-50 border-2 border-gray-300 rounded-lg">
            <a
              href={
                i18n.language === "fr"
                  ? "bioport-HLA-orientation-don.pdf"
                  : "bioport-HLA-donations-guidelines.pdf"
              }
              target="_blank"
              className="hover:underline"
            >
              <FontAwesomeIcon
                icon={faCircleInfo}
                size="xl"
                className="text-bioport-orange-dark mr-2"
              />
              {t("login.more_information")}
            </a>
          </div>
          <div className="mx-auto mt-2 lg:mt-4 p-4 px-6 xl:flex w-full md:w-1/2 lg:w-3/5">
            <div className="xl:w-1/2 pb-6">
              <div className="text-2xl mb-4 text-bioport-blue font-bold">
                {t("login.sign_in")}
              </div>
              <input
                {...form.register("username")}
                name="username"
                type="text"
                className="w-full"
                placeholder={t("login.email")}
              />
              <div className="relative">
                <input
                  {...form.register("password")}
                  name="password"
                  type={passwordShown ? "text" : "password"}
                  className="w-full mt-1"
                  placeholder={t("login.pass")}
                />
                <div className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5">
                  <FontAwesomeIcon
                    icon={passwordShown ? faEyeSlash : faEye}
                    className="text-bioport-orange-dark cursor-pointer"
                    onClick={() => togglePasswordShown()}
                  />
                </div>
              </div>
              <FieldError error={form.formState?.errors?.password} />

              <div className="flex items-center justify-end mt-4 pt-3 mb-10">
                <div className="mt-1 italic text-sm hover:underline border-gray-400 text-gray-600 cursor-pointer pr-4 mr-4">
                  <NavLink to="/forgot">{t("login.password.forgot")} ?</NavLink>
                </div>
                <div>
                  <Button
                    className="btn btn-primary"
                    isloading={form.formState.isSubmitting}
                  >
                    {t("login.connect")}
                  </Button>
                </div>
              </div>
            </div>

            <div className="xl:w-1/2 xl:mt-0 ">
              <div className="text-2xl xl:ml-10 xl:pl-10 xl:pb-4 text-bioport-blue font-bold">
                {t("login.new_partner")}
              </div>

              <div className="justify-center py-5 rounded-lg items-center xl:ml-10 xl:pl-10 xl:pb-24">
                <Link
                  to={{ pathname: "/register" }}
                  state={{ role: "ROLE_PARTNER" }}
                  className=""
                >
                  <div className="text-center font-bold text-sm rounded-lg transition duration-200 cursor-pointer bg-bioport-orange hover:bg-bioport-orange-light uppercase text-white py-4 px-8">
                    {t("login.create_account_partner")}
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </form>
    </Base>
  );
}

export default Login;
